import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarSetupRead } from "./solar-read-retry"
import type { SolarProposalIncentivesDto } from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The eligible incentives as last refreshed. A pure read; it refuses (400)
 * until System Pricing is stored, so callers enable it once it is.
 */
export default function useSolarProposalIncentives(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<SolarProposalIncentivesDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.incentives(proposalId ?? ``),
    queryFn: () => solarProposalService.getIncentives(proposalId ?? ``),
    enabled: Boolean(proposalId) && enabled,
    retry: retrySolarSetupRead,
  })
}
